var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1400 %100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_225)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 12,
    fill: "url(#paint0_linear_2_225)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.523 121.186C561.523 121.155 561.525 121.125 561.525 121.095C561.525 104.579 548.237 91.1898 531.847 91.1898C519.694 91.1898 509.249 98.5515 504.66 109.09C503.496 108.888 502.299 108.781 501.078 108.781C489.508 108.781 480.129 118.232 480.129 129.891C480.129 141.549 489.508 151 501.078 151H563.161C571.357 151 578 144.305 578 136.047C578 127.789 571.357 121.095 563.161 121.095C562.608 121.095 562.061 121.126 561.523 121.186Z",
    fill: "url(#paint1_linear_2_225)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.25 98.7698C1018.25 98.704 1018.25 98.6387 1018.25 98.5729C1018.25 62.8271 989.496 33.8496 954.022 33.8496C927.72 33.8496 905.114 49.7824 895.182 72.5899C892.662 72.1528 890.073 71.9223 887.43 71.9223C862.389 71.9223 842.09 92.3771 842.09 117.609C842.09 142.841 862.389 163.296 887.43 163.296H1021.8C1039.53 163.296 1053.91 148.807 1053.91 130.934C1053.91 113.061 1039.53 98.5729 1021.8 98.5729C1020.6 98.5729 1019.42 98.6411 1018.25 98.7698Z",
    fill: "url(#paint2_linear_2_225)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_225",
    x1: -112,
    y1: -320.335,
    x2: -182.068,
    y2: 286.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851038,
    stopColor: "#E0F4FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_225",
    x1: 529.064,
    y1: 132.195,
    x2: 525.519,
    y2: 106.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_225",
    x1: 948.001,
    y1: 122.597,
    x2: 940.327,
    y2: 67.0051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundClouds);
export default __webpack_public_path__ + "static/media/BackgroundClouds.46d56810e83788a988c89f190fcc03cd.svg";
export { ForwardRef as ReactComponent };